/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OnboardingPhone/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function OnboardingPhone({
  children,
  viewPath = "/DesignSystem/Images/OnboardingPhone",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 1251,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 697
  
}) {
  return (<React.Fragment
>
<img
  data-testid="OnboardingPhone.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-Z27JefG': alignSelf,'--bc-2-Z27JefG': backgroundColor,'--bblr-3-Z27JefG': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Z27JefG': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Z27JefG': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Z27JefG': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-Z27JefG': typeof height === 'number' ? `${height}px` : height,'--mb-8-Z27JefG': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-Z27JefG': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-Z27JefG': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-Z27JefG': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-Z27JefG': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}